module.exports = __webpack_public_path__ + "static/media/Industrial-2.e417342e.jpg";